/**
 * CouponsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import CouponTokensContext from './coupon-tokens-context'
import {
  fetchCouponTokens,
  fetchCouponToken,
  fetchCouponTokenByQrCode,
  fetchCouponTokenByToken,
  fetchCouponTokenTransferTransactions,
  createCouponToken,
  createCouponTokenByTokenTransfer,
  createCouponTokenTransfer,
  createCouponTokenShare,
} from './coupon-tokens-api'
import getAllDataInParallel from '../../helpers/get-all-data-in-parallel'

export default function CouponTokensProvider({ children }) {

  function fetchCouponTokensAll(params) {
    return getAllDataInParallel({
      fn: (args) => fetchCouponTokens({
        ...params,
        ...args,
      }),
      key: 'couponTokens',
    })
  }
  const state = {
    createCouponToken,
    createCouponTokenByTokenTransfer,
    createCouponTokenTransfer,
    createCouponTokenShare,
    fetchCouponToken,
    fetchCouponTokenByQrCode,
    fetchCouponTokenByToken,
    fetchCouponTokenTransferTransactions,
    fetchCouponTokens,
    fetchCouponTokensAll,
  }
  return (
    <CouponTokensContext.Provider value={state}>
      {children}
    </CouponTokensContext.Provider>
  )
}
